// home text slider js
jQuery(document).ready(function($) {
  $('.slick.marquee').slick({
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false
  });

// product page small thumbnail image

  $(".slider_thum").slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      vertical: true,
      verticalSwiping: true,
      swipeToSlide: true,
      focusOnSelect: true,
      nextArrow: '<button type="button" class="slick-next"><svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M31.5 15.75L20.25 27L31.5 38.25" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      prevArrow: '<button type="button" class="slick-prev"><svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.5 15.75L33.75 27L22.5 38.25" stroke="#333333" stroke-linecap="round" stroke-linejoin="round"/></svg></button>'
  });


  
}); 


// Home page featured collection tabs js

  $(document).ready(function() {
    $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
 });

// Featured collection tab slider
$(document).ready(function() {
  $('.featured-tab-slider-1s').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1
  });

});


// Header dropdown menu js
$(document).on("click",".header__submenu li details", function(){
    $('.header__submenu li details').removeAttr('open');
        $(this).prop('details','open');

});

document.querySelectorAll('.childmenu').forEach(summary => {
    summary.addEventListener('click', () => {
        const accordionContent = summary.nextElementSibling;

        summary.classList.toggle('active');

        if (summary.classList.contains('active')) {
            accordionContent.style.maxHeight = accordionContent.scrollHeight + 'px';
        } else {
            accordionContent.style.maxHeight = 0;
        }

        // Close other open accordion items
        document.querySelectorAll('.childmenu').forEach(otherButton => {
            if (otherButton !== summary) {
                otherButton.classList.remove('active');
                otherButton.nextElementSibling.style.maxHeight = 0;
            }
        });
    });
});



